import type { EnvironmentConfig } from './types';

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

if (!ENVIRONMENT) {
  throw new Error(
    'REACT_APP_ENVIRONMENT not set. Use npm run start:fhir or npm run start:nbn'
  );
}

// Import JSON config (copied from ../config/environments during prebuild)
let config: EnvironmentConfig;

try {
  config = require(`./environments/${ENVIRONMENT}.json`);
} catch (error) {
  const errorMessage = error instanceof Error ? error.message : String(error);
  throw new Error(
    `Failed to load environment "${ENVIRONMENT}".\n` +
    `Check that src/config/environments/${ENVIRONMENT}.json exists.\n` +
    `Error: ${errorMessage}`
  );
}

if (!config.id || !config.display || !config.ai) {
  throw new Error(`Invalid configuration for environment "${ENVIRONMENT}"`);
}

export const appConfig: EnvironmentConfig = config;
export type AppConfig = EnvironmentConfig;
